import React, { useEffect } from "react";
import { MaintenanceText, MaintenanceTextHeader, MaintenanceTextRegular, MaintenanceTop, MaintenanceWrap } from "./styles";
import Footer from "../Footer/Footer";

interface IMaintenance {
  maintenanceMessage: string;
};

export const MaintenanceInfo = ({ maintenanceMessage }: IMaintenance) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Down for Maintenance";
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <MaintenanceWrap>
      <MaintenanceTop>
        <MaintenanceText role="status">
          <MaintenanceTextHeader>Down for Maintenance</MaintenanceTextHeader>
          {maintenanceMessage && <MaintenanceTextRegular>{maintenanceMessage}</MaintenanceTextRegular>}
        </MaintenanceText>
      </MaintenanceTop>
      <Footer hideLinks={true} />
    </MaintenanceWrap>
  );
};
